<template>
    <p class="p-m-0">Indicaciones para cambiar su contraseña.</p>
    <ol class="p-mt-2">
        <li>Debe dirigirse al <a href='https://empleados.ugb.edu.sv/Login?ReturnUrl=%2f' target='_blank'>Portal del empleado</a>.</li>
        <li>Iniciar sesión con sus credenciales</li>
        <li>En el menú lateral desglosar la opción de configuración</li>
        <li>Seleccionar la opción de "cambiar contraseña"</li>
        <li>Definir su nueva clave y guardar los cambios</li>
    </ol>
</template>
<style scoped>
    li{
        padding:3px 0px;
    }
</style>
<script>
export default {
    name : 'CambiarClaveEmpleado'
}
</script>
